// extracted by mini-css-extract-plugin
module.exports = {"padding":"Content_padding__Nv1tx","content":"Content_content__A0UhB","narrow":"Content_narrow__DHizz"};